/* eslint-disable @typescript-eslint/no-explicit-any */
import { useFormik } from "formik";
import { useDispatch, useSelector } from "react-redux";
import { notification } from "@/store/modules/notification.ts";
import { StoreUtil } from "@/util/store/StoreUtil.ts";
import { BaseInput } from "../input/BaseInput.tsx";
import { RootState } from "@/store/modules";
import { deploySchema } from "@/utilities/validation/entitySchema.ts";
import { useState } from "react";
import axios from "axios";

export type NewModuleType = {
  onClose: () => void;
  data?: any;
};

export default function DeployForm({ onClose, data }: Readonly<NewModuleType>) {
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch<any>();
  const applicationState = useSelector((state: RootState) => state.application);
  const currentApplicationId =
    applicationState?.selectedApplication?.applicationId;
  const authState = useSelector((state: RootState) => state.auth);
  const showMessage = (
    response: any,
    title: "error" | "Success" = "Success",
    type: "error" | "success" = "success"
  ) => {
    StoreUtil.execute(() => {
      dispatch(
        notification.mutation.openModal({
          type,
          title,
          body: response,
        })
      );
    });

    onClose();
  };

  const handleSubmit = async (values: { repo_name: string }) => {
    const payload = {
      userId: authState?.userInfo?.userId,
      appId: currentApplicationId,
      repo_name: values?.repo_name,
    };

    console.log("payload: ", payload);
    setLoading(true);

    try {
      const res = await axios.post(
        "https://3gtiecsm6jguvxl777ino6jdqa0vftld.lambda-url.us-east-1.on.aws/repo/create-repo-with-appId",
        payload
      );

      console.log(res.data);
      showMessage("Repository Successfully Created", "Success", "success");
    } catch (error: any) {
      let message = "Something went wrong.";

      const errorData = error?.response?.data;

      if (errorData?.error?.type === "RepoCreationError") {
        message = "Repository already exists. Please choose a different name.";
      } else if (errorData?.error?.message) {
        message = errorData.error.message;
      } else if (errorData?.detail) {
        message = errorData.detail; // ✅ This is the actual message: 'User not authorized with Github.'
      } else if (error?.message) {
        message = error.message;
      }

      showMessage(message, "error", "error");
      console.error(error, "error message");
    } finally {
      setLoading(false);
    }
  };

  const formik = useFormik({
    onSubmit: handleSubmit,
    initialValues: { repo_name: "" },
    validationSchema: deploySchema,
  });

  return (
    <form onSubmit={formik.handleSubmit}>
      <div className="div-block-4">
        <BaseInput
          formik={formik}
          className="form_input w-input"
          maxLength={256}
          name="repo_name"
          data-name="repo_name"
          placeholder=""
          type="text"
          id="repo_name"
        />
      </div>

      <div className="div-block-5 div-flex">
        <BaseInput
          type="submit"
          formik={formik}
          className="button w-button"
          loading={loading}
          disabled={!formik.isValid}
          value="Create Repo"
        />
        <a className="button is-secondary w-button" onClick={onClose}>
          Cancel
        </a>
      </div>
    </form>
  );
}
